import { createMuiTheme } from '@material-ui/core/styles'
import {
  lighten,
  darken,
  fade,
} from '@material-ui/core/styles/colorManipulator'

const primary = '#2A4B78'
const secondary = '#FCD20F'
const Theme = createMuiTheme({
  useNextVariants: true,
  typography: {
    fontSize: 18,
    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
  },
  palette: {
    // primary: {
    //   light: '#40bbbf',
    //   main: '#032B43',
    //   dark: '#0b777b',
    // },
    // secondary: {
    //   light: green[300],
    //   main: '#3ec1af',
    //   // main: '#287C71',
    //   dark: green[700],
    primary: {
      extraLight: '#B9DCFC',
      mediumLight: lighten(primary, 0.5),
      light: lighten(primary, 0.3),
      main: primary,
      dark: darken(primary, 0.3),
    },
    secondary: {
      // light: '#FFD342',
      light: lighten(secondary, 0.3),
      main: secondary,
      // dark: '#E0A600',
      dark: darken(secondary, 0.3),
    },
    // accent: {
    //   light: '#FFF245',
    //   main: '#FFEE00',
    //   dark: '#D1C300',
    // },
    text: {
      secondary: fade(primary, 0.65),
      primary: fade(primary, 0.9),
    },
  },
  utils: {
    image: {
      round: {
        borderRadius: '50%',
      },
    },
  },
  banner: {
    height: '100vh',
    // backgroundColor: fade(secondary, 0.8),
    backgroundColor: lighten(primary, 0.85),
    // backgroundColor: '#8CB7E3',
  },
})

Theme.overrides = {
  MuiListItemIcon: {
    root: {
      marginRight: 0,
      color: primary,
    },
  },
  MuiListItem: {
    dense: {
      paddingTop: '4px',
      paddingBottom: '4px',
    },
  },
  MuiTypography: {
    h4: {
      fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
      [Theme.breakpoints.down('xl')]: {
        fontSize: `calc(${Theme.typography.h4.fontSize} * 0.1)`,
      },
      [Theme.breakpoints.down('lg')]: {
        fontSize: `calc(${Theme.typography.h4.fontSize} * 0.9)`,
      },
      [Theme.breakpoints.down('md')]: {
        fontSize: `calc(${Theme.typography.h4.fontSize} * 0.8)`,
      },
      [Theme.breakpoints.down('sm')]: {
        fontSize: `calc(${Theme.typography.h4.fontSize} * 0.7)`,
      },
    },
    h3: {
      fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    },
    h1: {
      fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    },
    h2: {
      fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
      lineHeight: '1.25',
      [Theme.breakpoints.down('xl')]: {
        fontSize: `calc(${Theme.typography.h2.fontSize} * 1)`,
      },
      [Theme.breakpoints.down('lg')]: {
        fontSize: `calc(${Theme.typography.h2.fontSize} * 0.7)`,
      },
      [Theme.breakpoints.down('md')]: {
        fontSize: `calc(${Theme.typography.h2.fontSize} * 0.6)`,
      },
      [Theme.breakpoints.down('sm')]: {
        fontSize: `calc(${Theme.typography.h2.fontSize} * 0.5)`,
      },
    },
  },
}

export default Theme
